import { TemaTokens, TvPlaylistItem } from "../../interfaces/PaineisTvTema";

export { momentoDeRenovar } from "../admin/paineis/logica";

/** Intervalo entre consultas à playlist (detecta TV desativada e mudança de itens). */
export const PLAYLIST_RECHECK_MS = 5 * 60_000;
export const ESPERA_MAXIMA_MS = 60_000;
const ESPERA_INICIAL_MS = 2_000;

/** Próximo item do rodízio; volta ao primeiro no fim. */
export function proximoIndice(atual: number, total: number): number {
  if (total <= 0) return 0;
  return (atual + 1) % total;
}

/** Espera crescente (dobra a cada falha) com teto de 60 s. `tentativa` começa em 0. */
export function esperaReconexao(tentativa: number): number {
  const n = Math.max(0, Math.floor(tentativa));
  return Math.min(ESPERA_MAXIMA_MS, ESPERA_INICIAL_MS * 2 ** Math.min(n, 10));
}

/** A TV só recomeça o rodízio se a lista de itens mudou de fato (evita piscar a cada consulta). */
export function itensMudaram(antes: TvPlaylistItem[], depois: TvPlaylistItem[]): boolean {
  if (antes.length !== depois.length) return true;
  return antes.some((a, i) => {
    const b = depois[i];
    return a.reportId !== b.reportId || a.aba !== b.aba || a.segundos !== b.segundos || a.indice !== b.indice;
  });
}

/* ---- Tema (cópia local da conversão: o TemaProvider é de outro pacote) ---- */

/** "#RRGGBB" ou "#RGB" → "r g b"; entrada inválida → null. */
export function hexParaRgb(hex: string): string | null {
  const m = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(hex.trim());
  if (!m) return null;
  const h = m[1].length === 3 ? m[1].replace(/./g, "$&$&") : m[1];
  const n = parseInt(h, 16);
  return `${(n >> 16) & 255} ${(n >> 8) & 255} ${n & 255}`;
}

/** Escurece "r g b" pela fração (0.12 = 12%). */
export function escurecerRgb(rgb: string, fracao: number): string {
  return rgb
    .split(" ")
    .map((c) => Math.round(Number(c) * (1 - fracao)))
    .join(" ");
}

/** Variáveis CSS do tema, para aplicar num elemento (escopo da TV). Sem primária válida → {}. */
export function variaveisDoTema(tokens: TemaTokens | null | undefined): Record<string, string> {
  const primaria = tokens ? hexParaRgb(tokens.primaria) : null;
  if (!tokens || !primaria) return {};
  const v: Record<string, string> = {
    "--tema-primaria-rgb": primaria,
    "--tema-primaria-600-rgb": escurecerRgb(primaria, 0.12),
  };
  const mapa: Array<[keyof TemaTokens, string]> = [
    ["fundo", "--dv-canvas"],
    ["superficie", "--dv-surface"],
    ["texto", "--dv-text"],
    ["textoSuave", "--dv-text-muted"],
    ["borda", "--dv-border"],
  ];
  mapa.forEach(([token, variavel]) => {
    const valor = tokens[token];
    if (typeof valor === "string" && valor) v[variavel] = valor;
  });
  if (tokens.raio != null) v["--dv-radius"] = `${tokens.raio}px`;
  if (tokens.fonte) v["--dv-font-sans"] = tokens.fonte;
  return v;
}
